import { Component } from '@angular/core';

@Component({
  selector: 'app-four-oh-four-component',
  templateUrl: './four-oh-four-component.component.html',
  styleUrls: ['./four-oh-four-component.component.css']
})
export class FourOhFourComponentComponent {

}
